import React, { Component } from 'react';
import DittoShare from './../Ditto/DittoShare';
import DittoRotateImageConatiner from '../ImageContainer/DittoRotateImageConatiner';
import DittoContainer from '../Ditto/DittoContainer';
import DittoPdpImageContainer from '../Ditto/DittoPdpImageContainer';
import DittoCarousal from '../Ditto/DittoCarousal';
import getSetCookie from '../../../../cookie';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonCallsActionCreators from '../../../../actionCreators/common';
import LKModal from '../../Modal/Modal';
import './TryOnPopUp.scss';
import * as dittoActions from '../../../../actionCreators/ditto';

class TryOnPopUp extends Component {
  constructor() {
    super();
    this.state = {
      rotateImgPath:
        'https://static2.lenskart.com/media/catalog/product/cache/1/thumbnail/480x480/9df78eab33525d08d6e5fb8d27136e95//v/i/vincent-chase-polarized-vc-s11075-c7-sunglasses_7i5a6934_1_1.jpg',
      headturnVisible: false,
      shouldShowDittoComponent: true,
      dittoId: '',
      visibleEmailUp: false,
      overlayedDittoImage: null,
    };
    this.setImageProps = this.setImageProps.bind(this);
    this.setDittoComponentState = this.setDittoComponentState.bind(this);
    this.fnCreateMyDitto = this.fnCreateMyDitto.bind(this);
  }
  componentDidMount() {
    const {
      commonCallsAction,
      dittoProfile,
      refreshDittoProfile,
      loginStatus,
      redisCommonData,
      dittoActions,
      productData,
      userInfo,
    } = this.props;

    if (!redisCommonData?.ENABLE_CYGNUS && (!dittoProfile || refreshDittoProfile) && loginStatus) {
      commonCallsAction.getDittoProfiles();
    }

    if (redisCommonData?.ENABLE_CYGNUS) {
      this.resetDittoImage();
    }
    if (
      redisCommonData?.ENABLE_CYGNUS &&
      (getSetCookie.getCookie('guest_dittoid') || loginStatus)
    ) {
      dittoActions.getOverlayedDitto(
        productData?.id,
        userInfo?.telephone,
        userInfo?.phoneCode,
        null,
        'desktop'
      );
    }
  }

  componentDidUpdate(prevProps) {
    const {
      commonCallsAction,
      dittoProfile,
      refreshDittoProfile,
      loginStatus,
      redisCommonData,
      productData,
      userInfo,
      overlayedDittoData,
      dittoActions,
    } = this.props;
    if (
      prevProps.loginStatus !== loginStatus &&
      !redisCommonData?.ENABLE_CYGNUS &&
      (!dittoProfile || refreshDittoProfile) &&
      loginStatus
    ) {
      commonCallsAction.getDittoProfiles();
    }
    if (prevProps.loginStatus !== loginStatus && redisCommonData?.ENABLE_CYGNUS && loginStatus) {
      dittoActions.getOverlayedDitto(
        productData?.id,
        userInfo?.telephone,
        userInfo?.phoneCode,
        null,
        'desktop'
      );
    }

    if (prevProps.overlayedDittoData !== overlayedDittoData && overlayedDittoData) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ overlayedDittoImage: overlayedDittoData?.overlayed_image_url });
    }
  }

  setImageProps(img) {
    this.setState({
      rotateImgPath: img,
      headturnVisible: true,
      shouldShowDittoComponent: false,
    });
  }

  setDittoComponentState(id) {
    commonCallsActionCreators.dittoAuth({ dittoId: id });
    const { commonCallsAction } = this.props;
    getSetCookie.setCookie('isDittoID', id);
    commonCallsAction.setDitto(id);
    this.setState({
      shouldShowDittoComponent: true,
      headturnVisible: false,
      dittoId: id,
    });
  }

  fnCreateMyDitto(cta, product) {
    this.sendDTM(cta, product);
    localStorage.setItem('dittoCompare', window.location.href);
    window.location.href = '/compare-looks';
  }

  sendDTM(cta, product) {
    const category = product.type;
    const subCategory = product.subCategories;
    const productId = product.id;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.ditto.click.pdp.triggerDTM(category, subCategory, productId, cta);
  }

  showEmailPopUp(value) {
    this.setState({ visibleEmailUp: value });
  }

  imgErrorRepSrc = event => {
    event.target.src = 'https://static.lenskart.com/media/mobile/images/no-image.png';
    event.target.style = 'width: 60vw;';
  };

  resetDittoImage() {
    this.setState({ overlayedDittoImage: null });
  }

  render() {
    const {
      productData,
      dittoProfile,
      showTryOnPopUp,
      close,
      dataLocale,
      loginStatus,
      redisCommonData,
      overLayedDittoError,
    } = this.props;
    const {
      DITTO_CREATE_NEW_BTN = 'Create New',
      SHARE,
      DITTO_TRY_ON_HEADING,
      PRODUCT_LINK_COPIED_TEXT,
      COPY_NOT_SUPPORTED_TEXT,
      CLOSE,
      LOGO,
      SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN,
      FRAME_IMAGE_NOT_AVAILBALE,
    } = dataLocale || {};
    const {
      rotateImgPath,
      headturnVisible,
      shouldShowDittoComponent,
      dittoId,
      visibleEmailUp,
      overlayedDittoImage,
    } = this.state;
    const isDitto = redisCommonData?.ENABLE_CYGNUS
      ? productData?.isCygnusEnabled
      : productData.isDittoEnabled;
    return (
      <LKModal
        keyboard
        backdrop="static"
        bodyClassName="padding-0"
        dialogClassName="try-on-modal"
        hideHandler={close}
        showModal={showTryOnPopUp}
        size="small"
      >
        <div className="padding-20">
          <div className="display-flex align-items-center">
            <div className="tryon-title fs28">{DITTO_TRY_ON_HEADING}</div>
            <div aria-label="close btn" onClick={() => close()}>
              <img alt={CLOSE} className="cursor-pointer" src="/assets/svg/Cross.svg" />
            </div>
          </div>
          <div className="display-flex margin-t20 margin-b30">
            {!redisCommonData?.ENABLE_CYGNUS && (
              <div className="flex-basis-88 product-image-container">
                {headturnVisible && (
                  <DittoRotateImageConatiner
                    dataLocale={dataLocale}
                    headturnVisible={headturnVisible}
                    productData={productData}
                    rotateImgPath={rotateImgPath}
                  />
                )}
                {shouldShowDittoComponent && (
                  <DittoContainer
                    {...this.props}
                    dataLocale={dataLocale}
                    dittoVisible={shouldShowDittoComponent}
                  />
                )}
                {getSetCookie.getCookie('isDittoID') && (
                  <DittoPdpImageContainer
                    {...this.props}
                    dittoId={dittoId}
                    isDitto={isDitto}
                    loginStatus={loginStatus}
                    setDittoComponentState={this.setDittoComponentState}
                  />
                )}
              </div>
            )}
            {redisCommonData?.ENABLE_CYGNUS && overlayedDittoImage && (
              <div className="flex-basis-100 product-image-container">
                <img alt="ditto" src={overlayedDittoImage} onError={this.imgErrorRepSrc} />
              </div>
            )}
            {redisCommonData?.ENABLE_CYGNUS && overLayedDittoError?.errorCode === 400 && (
              <div className="flex-basis-100 product-image-container">
                <p>{FRAME_IMAGE_NOT_AVAILBALE}</p>
              </div>
            )}
            {redisCommonData?.ENABLE_CYGNUS &&
              overLayedDittoError &&
              overLayedDittoError?.errorCode !== 400 && (
                <div className="flex-basis-100 product-image-container">
                  <p>{SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN}</p>
                </div>
              )}

            {redisCommonData?.ENABLE_CYGNUS && !overlayedDittoImage && !overLayedDittoError && (
              <div className="flex-basis-100 product-image-container">
                <div className="text-center padding-t15">
                  <img
                    alt={LOGO}
                    src="//static.lenskart.com/skin/frontend/base/default/images/loader2.gif"
                  />
                </div>
              </div>
            )}
            {/* {redisCommonData?.ENABLE_CYGNUS && overlayedDittoImage && (
              <div className="flex-basis-12 text-center padding-10 share-container">
                <div className="text-center fs12 fw600 padding-t10 padding-b10">{SHARE}</div>
                <DittoShare
                  copyNotSupportedText={COPY_NOT_SUPPORTED_TEXT}
                  dataLocale={dataLocale}
                  headturnVisible={headturnVisible}
                  productData={productData}
                  productLinkCopiedText={PRODUCT_LINK_COPIED_TEXT}
                  selectedDittoId={dittoId}
                  showEmailPopUp={value => this.showEmailPopUp(value)}
                />
              </div>
            )} */}
            {!redisCommonData?.ENABLE_CYGNUS && (
              <div className="flex-basis-12 text-center padding-10 share-container">
                <div className="text-center fs12 fw600 padding-t10 padding-b10">{SHARE}</div>
                <DittoShare
                  copyNotSupportedText={COPY_NOT_SUPPORTED_TEXT}
                  dataLocale={dataLocale}
                  headturnVisible={headturnVisible}
                  productData={productData}
                  productLinkCopiedText={PRODUCT_LINK_COPIED_TEXT}
                  selectedDittoId={dittoId}
                  showEmailPopUp={value => this.showEmailPopUp(value)}
                />
              </div>
            )}
          </div>
          {redisCommonData?.ENABLE_CYGNUS && overlayedDittoImage && (
            <div style={{ visibility: visibleEmailUp ? 'hidden' : 'visible' }}>
              <button
                key="ditto-create-btn"
                aria-label="try on btn"
                className="create-new-btn fs11 margin-r5 fw600 text-center bora-4"
                onClick={() => this.fnCreateMyDitto('Try On', productData)}
              >
                {DITTO_CREATE_NEW_BTN}
              </button>
            </div>
          )}
          {!redisCommonData?.ENABLE_CYGNUS &&
            (dittoProfile || !loginStatus ? (
              <div style={{ visibility: visibleEmailUp ? 'hidden' : 'visible' }}>
                <DittoCarousal
                  dittoCreateNewBtn={DITTO_CREATE_NEW_BTN}
                  fnCreateMyDitto={this.fnCreateMyDitto}
                  loginStatus={loginStatus}
                  productData={productData}
                  setDittoComponentState={this.setDittoComponentState}
                  setRotateImageProps={this.setImageProps}
                />
              </div>
            ) : (
              <div className="text-center padding-t15">
                <img
                  alt={LOGO}
                  src="//static.lenskart.com/skin/frontend/base/default/images/loader2.gif"
                />
              </div>
            ))}
        </div>
      </LKModal>
    );
  }
}

const mapStateToProps = state => ({
  dittoProfile: state.common.dittoProfile,
  refreshDittoProfile: state.common.refreshDittoProfile,
  dataLocale: state.locale,
  loginStatus: state.common.login,
  userInfo: (state.common.userInfo && state.common?.userInfo?.result) || null,
  overlayedDittoData: state.ditto.overlayedDittoData,
  overlayedDittoLoading: state.ditto.overlayedDittoLoading,
  overLayedDittoError: state.ditto.overLayedDittoError,
  redisCommonData: state.common.redisCommonData,
});

function mapDispatchToProps(dispatch) {
  return {
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    dittoActions: bindActionCreators(dittoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TryOnPopUp);
